const titlesUser = [
  { value: "M.", label: "Monsieur" },
  { value: "Mme", label: "Madame" },
];

export default titlesUser;
